import http from '@/utils/request.js'

/**
 * 获取项目状态计算
 * @returns 
 */
export const getCodingCount = () => {
  return http.request({
    url: "/index/codingCount",
    method: "GET",
  })
}

/**
 * 获取项目下拉选择列表
 * @returns 
 */
export const getProjectSelectList = () =>{
  return http.request({
    url:"/index/getSelect",
    method:"GET"
  })
}
/**
 * 流程状态统计信息
 * @param {*} params 
 * @returns 
 */
export const getTaskStatus = (params) =>{
  return http.request({
    url:"/index/taskStatus",
    method:"POST",
    data:params
  })
}
/**
 * 阶段统计
 * @returns 
 */
export const getStageCount = () =>{
  return http.request({
    url:"/index/stageCount",
    method:"GET"
  })
}
